<template>
	<div class="company-order-wrapper">
		<EmptyPage 
			v-if="projectCaseOrderList.length === 0" 
			:height="480" 
			:loading="loading" />
		<div v-else>
			<div class="company-order">
				<div 
					class="company-order-item" 
					v-for="(item, index) in projectCaseOrderList" 
					:key="index">
					<ServiceCard :data="item"/>
				</div>
			</div>
			<div 
				class="loading" 
				v-show="scrollLoading">
				<i class="el-icon-loading"></i>
			</div>
			<!-- 分页 -->
			<div class="company-order__pagination">
				<el-pagination
					background
					layout="prev, pager, next"
					:hide-on-single-page="true"
					:page-size="pageSize"
					:current-page="pageNum"
					:total="total"
					@current-change="handlePageChange">
				</el-pagination>
			</div>
		</div>
		<!-- <material-detail v-if="material" :material.sync="material" @updateMaterialList="updateMaterialList"></material-detail> -->
	</div>
</template>

<script>
import { mapState } from 'vuex';
import { getUserProjectCaseOrder } from '@/api/projectCase';
import { openWindow } from '@/utils/utils';
import ServiceCard from './ServiceCard';
// import MaterialDetail from './MaterialDetail';
import EmptyPage from '@/components/EmptyPage';
export default {
	name: 'ProjectCaseOrder',
    components: {
		ServiceCard,
		// MaterialDetail,
		EmptyPage
    },
    props: {
		// 各项标签
        tab: {
            type: Object,
            default: () => {}
		},
	},
	inject:['backTop'],
	data() {
		return {
			loading: true,
			scrollLoading: false,
			total: 0,
			pageSize: 40,
			pageNum: 1,
			pages: 1,
			// 列表
			projectCaseOrderList: [],
		}
	},
    computed: {
        ...mapState('app', ['scrollStatus'])
    },
	watch: {
		tab: {
			deep: true,
			handler() {
				Object.assign(this.$data, this.$options.data.call(this));
				this.getCompanyOrder();
			}
		},
		// scrollStatus() {
		// 	if (!this.user && !this.scrollLoading) {
		// 		this.scroll();
		// 	}
		// },
		type() {
			this.projectCaseOrderList = [];
			this.total = 0;
			this.pageSize = 40;
			this.pageNum = 1;
			this.pages = 1;
			this.getCompanyOrder();
		}
		// material: {
		// 	deep: true,
		// 	handler(val) {
		// 		if (!val) {
		// 			this.pageNum = 1;
		// 			this.getCompanyOrder();
		// 		}
		// 	}
		// },
	},
	created() {
		this.getCompanyOrder();
	},
	methods: {
		handlePageChange(pageNum) {
            this.pageNum = pageNum;
            this.backTop();
            this.getCompanyOrder();
        },
        // 无限滚动
        scroll() {
            if (this.pageNum > 100) return;
            if (this.pageNum >= this.pages) return;
            this.scrollLoading = true;
            this.pageNum++;
            this.getCompanyOrder();
        },
		// 获取项目案例
		getCompanyOrder() {
			getUserProjectCaseOrder().then(({ data }) => {
				this.projectCaseOrderList.push(...data);
				this.total = data.total || data.length;
				this.pages = data.pages || 1;
			}).finally(() => {
				this.loading = false;
				this.scrollLoading = false;
			});
		},
		// 免费付费项目案例列表查询
		getList() {
			return getCompanyOrder({
				pageNum: this.pageNum,
				pageSize: this.pageSize,
				fId: this.tab.format,
				cId: this.tab.category,
				lId: this.tab.label
			});
		},
		// 用户收藏项目案例列表查询
		getUserCollection() {
			return getUserCollectionMaterials({
				userId: this.user.id
			});
		},
		setMaterial(material) {
			if (!material.id) {
				return;
			}
			openWindow(`/#/material/detail/${material.id}`)
		}
	}
}
</script>

<style lang="scss" scoped>
.company-order {

    &-item {
        display: inline-block;
        margin-right: 20px;
        margin-top: 20px;
        width: 345px;
    }
	&__pagination {
        margin-top: 45px;
		padding-bottom: 30px;
        text-align: center;
    }
}
.loading {
    margin: 20px 0;
    text-align: center;
    font-size: 32px;
}
@include mq($small) {
    .company-order {
        padding-top: 15px;
        &-item {
            margin-right: 10px;
            margin-top: 10px;
			width: 290px;
        }
    }
}
</style>
